import { combineReducers } from '@reduxjs/toolkit';
import mainValidationsSlice from './MainValidations/mainValidationsSlice';
import subValidationsSlice from './SubValidations/subValidationsSlice';

export default combineReducers({
    mainValidations: mainValidationsSlice,
    subValidations: subValidationsSlice,
});
